export const REFERRAL_AMOUNT = 50;
export const REFERRAL_CURRENCY = 'EUR';

export const VALUE_PLACEHOLDER = '-';

// Accepts:
// - https://example.com
// - http://example.com
// - example.com
// - www.example.com
// plus optional path/query/hash
export const URL_REGEX = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(:\d{2,5})?(\/[^\s]*)?$/i;
